/** Pure replacement routing plus the compatibility entry points for callers. */

const HANDLERS = new Map();

export function replaceKindFor(target = {}) {
  if (target.provenance?.writable === false) return null;
  if (target.kind === 'logo') return 'logo';
  if (target.kind === 'background' || target.editableType === 'css-background') return 'background';
  if (target.kind === 'decoration') return target.editableType === 'image' ? 'image' : 'decoration';
  if (target.kind === 'icon') return target.editableType === 'image' ? 'image' : 'icon';
  if (target.kind === 'photo' || target.editableType === 'image') return 'image';
  return null;
}

export function canReplace(target) {
  return replaceKindFor(target) !== null;
}

export function setReplaceHandler(kind, handler) {
  if (!kind || !handler || typeof handler.openDialog !== 'function') {
    throw new TypeError('A replacement handler requires kind and openDialog');
  }
  HANDLERS.set(kind, Object.freeze({ ...handler }));
}

export function replaceHandlerFor(target) {
  return HANDLERS.get(replaceKindFor(target)) || null;
}

export async function replaceTarget(target, opts = {}) {
  try {
    const handler = replaceHandlerFor(target);
    if (handler) return await handler.openDialog({ target, ...opts });
    const { openReplaceDialog } = await import('./replace-dispatcher.js');
    return await openReplaceDialog({ target, ...opts });
  } catch {
    return { ok: false, reason: 'handler-error' };
  }
}

export async function removeTarget(target, opts = {}) {
  try {
    const handler = replaceHandlerFor(target);
    if (typeof handler?.remove === 'function') return await handler.remove({ target, ...opts });
    return { ok: false, reason: 'remove-handler-missing' };
  } catch {
    return { ok: false, reason: 'handler-error' };
  }
}
